import React, {useEffect, useRef, useState} from "react";
import Modal from "react-modal";
import {useTranslation} from "react-i18next";
import {IoClose} from "react-icons/io5";
import {MdFullscreen, MdFullscreenExit} from "react-icons/md";

import "./TradeBalanceChartModal.css";

const CHART_URL = "https://ews.mongolbank.mn/embed/chart/trade-balance?token=dHJhZGUtYmFsYW5jZS4xODE5MjczOTc3MDA0Lm51X3VWVkpMX3hNVjh5cklDRkNHUWtsU1VvTGJVTTRMYUR2d0xyYU9xU28&theme=light";

const appElement = document.getElementById("root");
if (appElement) {
    Modal.setAppElement(appElement);
}

const TradeBalanceChartModal = ({isOpen, onRequestClose}) => {
    const {t} = useTranslation();
    const chartContainerRef = useRef(null);
    const [isFullscreen, setIsFullscreen] = useState(false);

    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(document.fullscreenElement === chartContainerRef.current);
        };

        document.addEventListener("fullscreenchange", handleFullscreenChange);
        return () => document.removeEventListener("fullscreenchange", handleFullscreenChange);
    }, []);

    const toggleFullscreen = async () => {
        try {
            if (document.fullscreenElement === chartContainerRef.current) {
                await document.exitFullscreen();
            } else if (chartContainerRef.current?.requestFullscreen) {
                await chartContainerRef.current.requestFullscreen();
            }
        } catch (error) {
            console.error("Unable to change chart fullscreen mode", error);
        }
    };

    const closeModal = async () => {
        if (document.fullscreenElement === chartContainerRef.current) {
            try {
                await document.exitFullscreen();
            } catch (error) {
                console.error("Unable to exit chart fullscreen mode", error);
            }
        }
        onRequestClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            className="trade-balance-chart-modal"
            overlayClassName="trade-balance-chart-overlay"
            contentLabel={t("finance.chart.title")}
        >
            <div ref={chartContainerRef} className="trade-balance-chart-container">
                <div className="trade-balance-chart-header">
                    <h2>{t("finance.chart.title")}</h2>
                    <div className="flex items-center gap-2">
                        {document.fullscreenEnabled &&
                            <button
                                type="button"
                                onClick={toggleFullscreen}
                                className="trade-balance-chart-icon-button"
                                aria-label={isFullscreen
                                    ? t("finance.chart.exitFullscreen")
                                    : t("finance.chart.fullscreen")}
                                title={isFullscreen
                                    ? t("finance.chart.exitFullscreen")
                                    : t("finance.chart.fullscreen")}
                            >
                                {isFullscreen ? <MdFullscreenExit/> : <MdFullscreen/>}
                            </button>}
                        <button
                            type="button"
                            onClick={closeModal}
                            className="trade-balance-chart-icon-button"
                            aria-label={t("finance.chart.close")}
                            title={t("finance.chart.close")}
                        >
                            <IoClose/>
                        </button>
                    </div>
                </div>
                <iframe
                    src={CHART_URL}
                    title={t("finance.chart.iframeTitle")}
                    className="trade-balance-chart-iframe"
                    allow="fullscreen"
                    allowFullScreen
                />
            </div>
        </Modal>
    );
};

export default TradeBalanceChartModal;
